export default __webpack_public_path__ + "static/media/ga-logo-sm.e629bbbe.png";